import { Chip } from "../../../../components/common/chip";
import { Text } from "../../../../components/common/typography";
import { RadioOption } from "../../../../components/common/radio-option";

export type PaymentMethodId = "card" | "bank" | "pay_later" | "cash";

// `available: false` rows render greyed-out with a "Coming soon" chip and
// can't be selected. Card is the only PSP-backed method today (Stripe);
// the rest will land when we wire bank-rail / cash-on-delivery providers.
const METHODS: {
  id: PaymentMethodId;
  name: string;
  detail: string;
  available: boolean;
}[] = [
  { id: "card", name: "Credit / Debit card", detail: "Visa, Mastercard, Amex", available: true },
  { id: "bank", name: "Bank Transfer", detail: "Qatar National Bank, QIB, QIIB and others", available: false },
  { id: "pay_later", name: "Pay Later", detail: "Qatar National Bank, QIB, QIB and others", available: false },
  { id: "cash", name: "Cash when receiving the item", detail: "Limited to 10,000 QAR", available: false },
];

interface PaymentMethodSectionProps {
  selected: PaymentMethodId;
  onChange: (id: PaymentMethodId) => void;
}

export function PaymentMethodSection({ selected, onChange }: PaymentMethodSectionProps) {
  return (
    <div className="flex flex-col gap-2">
      {METHODS.map((method) => {
        const disabled = !method.available;
        return (
          <div
            key={method.id}
            className={disabled ? "pointer-events-none opacity-60" : undefined}
          >
            <RadioOption
              selected={selected === method.id}
              onClick={() => !disabled && onChange(method.id)}
            >
              <div className="flex w-full items-center justify-between gap-3">
                <div className="flex flex-col gap-0.5">
                  <Text variant="bodyBold" tone="dark">{method.name}</Text>
                  <Text variant="bodySm" tone="muted">{method.detail}</Text>
                </div>
                {disabled && <Chip variant="tertiary">Coming soon</Chip>}
              </div>
            </RadioOption>
          </div>
        );
      })}
    </div>
  );
}
